import React from "react";
import { Routes, Route, Navigate, Link } from "react-router-dom";

import Home from "./page/home";
import Grooneapp from "./page/grooneapp";
import Solution from "./page/solution";
import Media from "./page/media";
import MediaDetail from "./page/media-detail";
import Investor from "./page/investor";
import PrivacyPolicy from "./page/privacy-policy";
import PageWrapper from "./page/page-wrapper";
import About from "./page/about";
import ThankYou from "./page/thankYou";
import ErrorPage from "./page/Nofound";
import ContactUs from "./page/NewContactus";
import Careers from "./page/careersNew";
import ContactUsNew from "./page/NewContactus";
import CareersNew from "./page/careersNew";
import RouteSEO from "./page/route-seo";

const AppRoutes: React.FC = () => {
  return (
    <>
    {/* <RouteSEO /> */}
      <Routes>
      {/* Routes WITHOUT PageWrapper */}
      <Route path="/resources/:category/:id" element={<MediaDetail />} />
      <Route path="/careers" element={<CareersNew />} />
      <Route path="/contact-us" element={<ContactUsNew />} />
      {/* Routes WITH PageWrapper */}
      <Route element={<PageWrapper />}>
        <Route path="/" element={<Home />} />
        <Route path="/gro-one-app" element={<Grooneapp />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/solutions" element={<Solution />} />
        <Route path="/investors" element={<Investor />} />
       
        <Route path="/resources" element={<Media />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/thank-you" element={<ThankYou />} />
   
      </Route>

      {/* Redirects */}
      <Route path="/career" element={<Navigate to="/careers" replace />} />
      <Route path="/solution" element={<Navigate to="/solutions" replace />} />
      <Route path="/investor" element={<Navigate to="/investors" replace />} />
      <Route path="/about" element={<Navigate to="/about-us" replace />} />
      <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
      <Route path="/index.html" element={<Navigate to="/" replace />} />

      {/* 404 */}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
    </>
  );
};

export default AppRoutes;
